import AjaxResolver from 'owd/module/ajax';

export default class TicketsResolver extends AjaxResolver {
	shouldPushState() {
		return true;
	}

	pageIn() {
		const deferred = $.Deferred();
		const info = $('.section--info');

		// $('html, body').animate({
		// 	scrollTop: `${sectionInfo.offset().top - 90}px`
		// }, 600);

		info.transition({
			opacity: 1
		}, 200, 'easeOutQuad', () => {
			// $('.tickets-nav').css({
			// 	'pointer-events': 'auto'
            // });
            if (window.innerWidth > 1199) {
                $('html, body').animate({
                    scrollTop: $('.section--info').offset().top - 118
                }, 600);
            }

            $('footer').fadeIn();

            $('*').css('cursor', '');

			deferred.resolve();
		});

		return deferred.promise();
	}

	pageOut() {
		const deferred = $.Deferred();
        const info = $('.section--info');
        
        $('*').css('cursor', 'wait', 'important');

		// $('.tickets-nav').css({
		// 	'pointer-events': 'none'
        // });
        
        if (info.length) {
            info.transition({
                opacity: 0
            }, 200, 'easeOutQuad', () => {
                deferred.resolve();
            });
        } else {
            deferred.resolve();
        }


		return deferred.promise();
	}

	updateContent($loadedContent) {
        const deferred = $.Deferred();
        const $newContainer = $loadedContent.find('.section--info');
		const $currentContainer = $('.section--info');
		// const $newActiveLink =  $loadedContent.find('.tickets-nav-item.active');
		// const $currentActiveLink = $('.tickets-nav-item.active');

        if ($currentContainer.length) {
            $newContainer.css({
                opacity: 0
            });

            $currentContainer.after($newContainer);
            $currentContainer.remove();
        } else {
            $('.section--tickets-hero').after($newContainer);
        }

		deferred.resolve([$currentContainer], [$newContainer]);

		return deferred.promise();
	}
}
